import accountingList from "./list.vue"
let a = Object.assign({ accountingList })
export default a